import './RAAccordionHeader.scss';

// @ vendors
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { recordEventCustomOnly } from 'utilities/uTagging';
// @ utilities
import { formatText } from 'core/i18n';
// @ components
import { RAAccordionButton } from '../RAAccordionButton/RAAccordionButton';
// @ assets
import ArrowDown from 'assets/icons/icon-arrow-down-red.svg';
// @ constants
import { TEST_PROCESS_STEP_STEP_4, EVENT_CATEGORY_SUITABILITY_TEST } from 'constants/uTagConstants/RAConstants';

export const RAAccordionHeader = ({
    expandAccordionRow,
    icon,
    id,
    isExpanded,
    title,
    buttons,
    formActions,
    profileModel,
    rowId,
    rowIndex,
    selectedOption,
    selectAccordionButton,
    userProfile,
    validateStep,
}) => {
    const handleClick = () => {
        expandAccordionRow(id);

        const moreInfoEventTag = () => {
            const zeroPad = (num, places) => String(num).padStart(places, '0');

            return `${zeroPad(rowIndex + 1, 2)} ${title} - más información`;
        };
        recordEventCustomOnly({
            accionEvento: TEST_PROCESS_STEP_STEP_4,
            categoriaEvento: EVENT_CATEGORY_SUITABILITY_TEST,
            etiquetaEvento: moreInfoEventTag(),
        });
    };

    const currentClassName = classNames('ra-accordion-header', {
        'ra-accordion-header--is-expanded': isExpanded,
    });
    const iconClass = `ra-accordion-header__icon ${icon}`;

    return (
        <div className={currentClassName}>
            <i className={iconClass} />
            <div className="ra-accordion-header__title">{title}</div>
            <div className="ra-accordion-buttons-wrapper">
                {buttons.map(button => (
                    <RAAccordionButton
                        formActions={formActions}
                        id={button.id}
                        key={button.id}
                        label={button.label}
                        model={button.id}
                        profileModel={profileModel}
                        rowId={rowId}
                        rowIndex={rowIndex}
                        selectAccordionButton={selectAccordionButton}
                        selectedOption={selectedOption}
                        userProfile={userProfile}
                        validateStep={validateStep}
                        title={title}
                    />
                ))}
            </div>
            {!isExpanded && (
                <div className="ra-accordion-header__more" onClick={handleClick}>
                    {formatText('initialAddInfoSection-accordionTitle')}
                    <img src={ArrowDown} alt="ArrowDown" className="svg-arrow-down" />
                </div>
            )}
        </div>
    );
};

RAAccordionHeader.propTypes = {
    buttons: PropTypes.array.isRequired,
    formActions: PropTypes.object.isRequired,
    profileModel: PropTypes.string.isRequired,
    rowId: PropTypes.string.isRequired,
    rowIndex: PropTypes.number,
    selectAccordionButton: PropTypes.func.isRequired,
    selectedOption: PropTypes.string,
    userProfile: PropTypes.object.isRequired,
    validateStep: PropTypes.func,
    expandAccordionRow: PropTypes.func.isRequired,
    icon: PropTypes.string,
    id: PropTypes.string.isRequired,
    isExpanded: PropTypes.bool,
    title: PropTypes.string,
};
